import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=0601f7d3&"
import script from "./Box.vue?vue&type=script&setup=true&lang=js&"
export * from "./Box.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Box.vue?vue&type=style&index=0&id=0601f7d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports